import React from 'react';
import Link from '@mui/material/Link';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    href,
    text,
    onClick,
    onKeyDown,
}: IProps) => {
    const getWord = useDictionary();

    return (
        <Link
            className="link"
            href={href}
            tabIndex={0}
            onClick={onClick}
            onKeyDown={onKeyDown}
        >
            {getWord(text)}
        </Link>
    );
};

const LinkComponent = React.memo(Component);

export default LinkComponent;
